import { useCallback, useMemo, useState } from 'react'
import { Virtuoso } from 'react-virtuoso'
import { usePayors } from '~/entities/payors'
import { SearchView, Text } from '~/shared/ui'
import { PayorItem } from './payor-item'

export function PayorFilter() {
  const {
    data: {
      data: { insurancePayors: payors },
    },
  } = usePayors()
  const [searchValue, setSearchValue] = useState('')

  const handleSearchChange = useCallback((value: string) => {
    setSearchValue(value)
  }, [])

  const filteredPayors = useMemo(() => {
    return payors.filter((payor) => {
      return (
        payor.payorId.toLowerCase().includes(searchValue.toLowerCase()) ||
        payor.payorName.toLowerCase().includes(searchValue.toLowerCase())
      )
    })
  }, [payors, searchValue])

  const visiblePayors = useMemo(() => {
    if (searchValue) {
      return filteredPayors
    }
    return payors
  }, [filteredPayors, payors, searchValue])

  return (
    <SearchView
      value={searchValue}
      onChange={handleSearchChange}
      placeholder="Search"
      forceOpen
      scrollable={false}
    >
      {visiblePayors.length > 0 ? (
        <>
          {visiblePayors.length < 5 ? (
            visiblePayors.map((payor) => (
              <PayorItem
                key={payor.payorId}
                payor={payor}
                searchValue={searchValue}
              />
            ))
          ) : (
            <Virtuoso
              className="min-h-[280px]"
              data={visiblePayors}
              itemContent={(_, payor) => {
                return (
                  <PayorItem
                    key={payor.payorId}
                    payor={payor}
                    searchValue={searchValue}
                  />
                )
              }}
            />
          )}
        </>
      ) : (
        <Text
          className="box-border w-full px-4 py-3"
          appearance="SUBTITLE"
        >
          No Results
        </Text>
      )}
    </SearchView>
  )
}
